import { render, staticRenderFns } from "./MainRoomInfo3.vue?vue&type=template&id=4fba8976&scoped=true&"
import script from "./MainRoomInfo3.vue?vue&type=script&lang=js&"
export * from "./MainRoomInfo3.vue?vue&type=script&lang=js&"
import style0 from "./MainRoomInfo3.vue?vue&type=style&index=0&id=4fba8976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba8976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VImg,VRow})
